export enum TitleStatus {
  Pending = "Pending",
  Completed = "Completed",
  Validated = "Validated",
  Cancelled = "Cancelled",
  Transfered = "Transfered",
}
